import { render, staticRenderFns } from "./Prize_successful_order.vue?vue&type=template&id=3358eb84&scoped=true"
import script from "./Prize_successful_order.vue?vue&type=script&lang=js"
export * from "./Prize_successful_order.vue?vue&type=script&lang=js"
import style0 from "./Prize_successful_order.vue?vue&type=style&index=0&id=3358eb84&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358eb84",
  null
  
)

export default component.exports